// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDy4wlk6hejBdCpH9baJtXgagGrB1L2QHo',
  authDomain: 'rocksmith-cf-champ-assistant.firebaseapp.com',
  projectId: 'rocksmith-cf-champ-assistant',
  storageBucket: 'rocksmith-cf-champ-assistant.appspot.com',
  messagingSenderId: '667874860237',
  appId: '1:667874860237:web:4dc20012efe04b38949d84',
  measurementId: 'G-RMD46HEBBP',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

export const db = getFirestore(app)
